import { NgModule } from '@angular/core';
import { TextMiddleEllipsisPipe } from './textMiddleEllipsis.pipe';

@NgModule({
    imports: [
    ],
    declarations: [
        TextMiddleEllipsisPipe
    ],
    exports: [
        TextMiddleEllipsisPipe
    ],
    providers: [
    ]
})

export class TextMiddleEllipsisPipeModule { }
